<template>
  <Modal content-class="goals-modal">
    <template #activator="{ onClick }">
      <span class="goals-modal__activator" @click="onClick">
        <svgo-help class="icon" />
      </span>
    </template>
    <template #content="{ close }">
      <div class="goals-modal__inner">
        <div class="goals-modal__head">
          <h2 class="goals-modal__title">
            {{ $t('project.project_goals') }}
          </h2>
        </div>
        <div class="goals-modal__content">
          <PagesProjectGoalsModalItem
            v-for="(goal, i) in goals"
            :key="i"
            :goal="goal"
            :index="i"
            :goals="goals"
            :project-finished="finished"
            :locale="locale"
          />
        </div>
        <UiButton v-if="!finished" @click="openDonateModal(close)">
          {{ $t('button.help') }}
        </UiButton>
        <div v-else class="goals-modal__donate-finish">
          <svgo-finish-donate class="icon" />
          <p>{{ $t('donate.completed') }}</p>
        </div>
      </div>
    </template>
  </Modal>
</template>
<script setup>
defineProps({
  goals: {
    type: Array,
    required: true,
  },
  locale: {
    type: String,
    required: true,
  },
  finished: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(['open-donate-modal']);

function openDonateModal(closeModal) {
  closeModal();
  emits('open-donate-modal');
}
</script>

<style lang="scss">
@use '@styles/components/pages/project/goalsModal.scss' as *;
</style>
